import styled from 'styled-components';
import { FiArrowRight } from 'react-icons/fi';

export const Container = styled.div`
  label > input {
    border-width: 1px !important;
  }
`;

export const IconNext = styled(FiArrowRight)`
  order: 5;
  margin-left: 5px;
  margin-top: 2px;
`;
